<template>
  <div>
    <v-row>
      <v-col> {{ isAT ? "Iniciativas" : "Soluções" }} desabilitadas </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="solutionsValue"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                {{ props.item.nome }}
              </td>
              <td>
                {{ props.item.descricao }}
              </td>
              <td>
                {{ props.item.municipioGrupoSolucao.nome }}
              </td>
              <td>
                {{ props.item.usuario && props.item.usuario.nome }}
              </td>
              <td>
                {{ props.item.justificativa }}
              </td>
              <td v-if="!props.item.municipioGrupoSolucao.desabilitado">
                <AppModalRecoverSolution
                  @onRecover="onRecoverM"
                  :payload="{
                    nomeGrupo: props.item.nome,
                    municipioid: props.item.municipioId,
                    solucaoid: props.item.municipioSolucaoId,
                  }"
                >
                </AppModalRecoverSolution>
              </td>
              <td
                v-if="props.item.municipioGrupoSolucao.desabilitado"
                class="desabilitado"
              >
                {{ isAT ? "Grupo de Iniciativas" : "Grupo de Soluções" }}
                Desabilitado
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <div>
              Não há {{ isAT ? "Iniciativas" : "Soluções" }} desabilitadas
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppModalRecoverSolution from "./ModalRecoverSolution";

export default {
  name: "AppRetrieveSolution",
  props: {
    solutions: { type: Array, required: true },
  },
  components: {
    AppModalRecoverSolution,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Solução",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Consultor",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        { text: "Habilitar", value: "acoes", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["loading", "isAT"]),
    solutionsValue() {
      let a = this.solutions.sort(function (a, b) {
        return (
          a.municipioGrupoSolucao.desabilitado -
          b.municipioGrupoSolucao.desabilitado
        );
      });

      return a;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onRecoverM() {
      this.$emit("onRecover");
    },
  },
  mounted() {
    if (this.isAT) {
      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupos de Iniciativa",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "ATS",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        { text: "Habilitar", value: "acoes", sortable: false },
      ];
    }
  },
};
</script>
<style scoped>
.desabilitado {
  color: red;
}
</style>
